import { useState, useEffect } from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import Topbar from "./scenes/global/Topbar";
import Sidebar from "./scenes/global/Sidebar";
import Dashboard from "./scenes/dashboard";
import ClientMonitoring from "./scenes/clientMonitoring/main";
import Retainersx from "./scenes/clientMonitoring/retainersx";
import Team from "./scenes/team";
import Invoices from "./scenes/invoices";
import TLServiceContracts from "./scenes/tlservicecontracts";
import TLMonitoringTasks from "./scenes/tlMonitoringTasks";
import TLCashReceipts from "./scenes/tlCashReceipts";
import TLSalesOnAccount from "./scenes/tlSalesOnAccount";
import TLBillingStatement from "./scenes/tlBillingStatement";
import TLPaymentVoucher from "./scenes/tlPaymentVoucher";
import TLPurchaseOnAccount from "./scenes/tlPurchaseOnAccount";
import TLJournalVoucher from "./scenes/tlJournalVoucher";
import TLJVTemplate from "./scenes/tlJVTemplate";
import TLRecurringJV from "./scenes/tlRecurringJV";
import TlClientProfile from "./scenes/tlClientProfile";
import InventoryDashboard from "./scenes/Inventory/DashboardInvty";
import InventoryReports from "./scenes/Inventory/ReportsInvty";
import LendingDashboard from "./scenes/LendingModule/LendingDashboard";
import BorrowersList from "./scenes/LendingModule/BorrowersList";
import MFBorrowers from "./scenes/LendingModule/MFBorrowers";
import LoanList from "./scenes/LendingModule/LoanList";
import Loans from "./scenes/LendingModule/Loans";

import InvtyINPurchaseOrder from "./scenes/Inventory/TransacInvty/InvtyIN/InvtyINPurchaseOrder";
import InvtyINReceiving from "./scenes/Inventory/TransacInvty/InvtyIN/InvtyINReceiving";
import TLReceivingReportWithPO from "./scenes/tlReceivingReportWithPO";
import InvtyINTransfer from "./scenes/Inventory/TransacInvty/InvtyIN/InvtyTransferIn";

import TLSalesOrder from "./scenes/tlSalesOrder";
import TLDeliveryReceiptsWithSO from "./scenes/tlDeliveryReceiptswithSO";
import InvtyOUTDelivery from "./scenes/Inventory/TransacInvty/InvtyOUT/InvtyOUTDelivery";
import InvtyOUTTransfer from "./scenes/Inventory/TransacInvty/InvtyOUT/InvtyTransferOut";
import TransPurchaseOrder from "./scenes/transactions/TransPurchaseOrder";
import TransReceivingReport from "./scenes/transactions/TransReceivingReport";
import TransReceivingReportWithPO from "./scenes/transactions/TransReceivingReportWithPO";
import TransDeliveryReceipt from "./scenes/transactions/TransDeliveryReceipt";
import TransDeliveryReceiptWithSO from "./scenes/transactions/TransDeliveryReceiptWithSO";
import TransSalesOrder from "./scenes/transactions/TransSalesOrder";
import CashReceiptTransaction  from "./scenes/transactions/TransCashReceipts/CashReceiptsTran/CashReceiptTransaction";
import TransSalesOnAccount from "./scenes/transactions/TransSalesOnAccount";
import TransPurchaseOnAccount from "./scenes/transactions/TransPurchaseOnAccount";
import TransPaymentVoucher from "./scenes/transactions/TransPaymentVoucher";
import TransJournalVoucher from "./scenes/transactions/TransJournalVoucher";
import TransRecurringJV from "./scenes/transactions/TransRecurringJV";
import Report_ARAging from "./scenes/Reports/AR_Reports/ARAgingReport/index.jsx";
import Report_LiquidationReport from "./scenes/Reports/AR_Reports/LiquidationReport";

import Report_ISACA_IS from "./scenes/Reports/FinancialReport_ISACA/IncomeStatement";
import Report_ISACA_BS from "./scenes/Reports/FinancialReport_ISACA/BalanceSheet";
import Report_ISACA_TB from "./scenes/Reports/FinancialReport_ISACA/TrialBalance";



import ChangePassword from "./scenes/settings/ChangePassword";

import AUD_CompanyProfile from "./scenes/AuditModule/AUD_CompanyProfile";
// import CashReceiptsTranClone from "./scenes/transactions/TransCashReceipts/CashReceiptsTranClone";
// import CashReceiptsTranEdit from "./scenes/transactions/TransCashReceipts/CashreceiptsTransEdit";
import Contacts from "./scenes/contacts";
import Bar from "./scenes/bar";
import Form from "./scenes/form";
import Line from "./scenes/line";
import Pie from "./scenes/pie";
import FAQ from "./scenes/faq";
import Geography from "./scenes/geography";
import Calendar from "./scenes/calendar/calendar";
import { useIdleTimer } from 'react-idle-timer';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { UserProvider } from "../src/scenes/clientMonitoring/components/UserContext";

import ConnString from "./ConnString.js";

const Connstring2 = ConnString.connstring;

const AppWrapper = () => {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);
  const navigate = useNavigate();
 
  const [userEmail, setUserEmail] = useState("");
  const [selectedCompany, setSelectedCompany] = useState("");
  const [compID, setcompID] = useState("");
  const [mainWidth, setMainWidth] = useState("100%");


 

    useEffect(() => {
    const email = sessionStorage.getItem("userEmail");
    const company = sessionStorage.getItem("selectedCompany");
    setUserEmail(email || "");
    setSelectedCompany(company || "");
    
    // console.log("✅ App opened by:", email, "with company:", company);
   }, []);


useEffect(() => {
  const updateWidth = () => {
    const screenWidth = window.innerWidth;
    if (screenWidth > 1440) {
      setMainWidth("1200px");
    } else if (screenWidth > 1024) {
      setMainWidth("90%");
    } else {
      setMainWidth("100%");
    }
  };

  updateWidth();
  window.addEventListener("resize", updateWidth);
  return () => window.removeEventListener("resize", updateWidth);
  }, []);


  const handleOnIdle = () => {
    console.log("⏳ User is idle. Logging out...");
    fetch(`${Connstring2}/api/logout`, {
      credentials: 'include',
      method: 'POST'
    }).then(() => {
      sessionStorage.clear();
      navigate('/');
    });
  };

  useIdleTimer({
    timeout: 1000 * 60 * 45, // ⏰ 5 minutes
    onIdle: handleOnIdle,
    debounce: 500,
  });

  const TOPBAR_HEIGHT = 64; 

  return (
     <LocalizationProvider dateAdapter={AdapterDateFns}>
         <UserProvider>
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className="app">
          <Sidebar isSidebar={isSidebar} />
        <main className="content" style={{ width: mainWidth, margin: "0 auto" }}>
            {/* <Topbar setIsSidebar={setIsSidebar} /> */}
         <div style={styles.topbarSticky}>
           <Topbar setIsSidebar={setIsSidebar} />
        </div>

        <div style={styles.pageBody}>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="monitoring" element={<ClientMonitoring />} />
              <Route path="retainer" element={<Retainersx />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="team" element={<Team />} />
              <Route path="contacts" element={<Contacts />} />
              <Route path="invoices" element={<Invoices />} />
              <Route path="TLServiceContracts" element={<TLServiceContracts />} />
              <Route path="TLCashReceipts" element={<TLCashReceipts />} />    
              <Route path="TLSalesOnAccount" element={<TLSalesOnAccount />} />
              <Route path="TLBillingStatement" element={<TLBillingStatement />} />
              <Route path="TLPaymentVoucher" element={<TLPaymentVoucher />} />
              <Route path="TLPurchaseOnAccount" element={<TLPurchaseOnAccount />} />
              <Route path="TLJournalVoucher" element={<TLJournalVoucher />} />
              <Route path="TLJVTemplate" element={<TLJVTemplate />} />
              <Route path="TLRecurringJV" element={<TLRecurringJV />} />
              <Route path="TLMonitoringTasks" element={<TLMonitoringTasks />} />       
              <Route path="TlClientProfile" element={<TlClientProfile />} />      
              <Route path="InventoryDashboard" element={<InventoryDashboard />} />
              <Route path="InventoryReport" element={<InventoryReports />} />
              <Route path="InventoryReports" element={<InventoryReports />} />
              <Route path="InventoryPurchaseOrder" element={<InvtyINPurchaseOrder />} />
              <Route path="InventoryReceivingPO" element={<TLReceivingReportWithPO />} />
              <Route path="InventoryReceiving" element={<InvtyINReceiving />} />
              <Route path="InventoryTransferIn" element={<InvtyINTransfer />} />
              <Route path="InventorySalesOrder" element={<TLSalesOrder />} />
              <Route path="InventoryDeliveryWithSO" element={<TLDeliveryReceiptsWithSO />} />
              <Route path="InventoryDelivery" element={<InvtyOUTDelivery />} />
              <Route path="InventoryTransferOut" element={<InvtyOUTTransfer />} />
              <Route path="LendingDashboard" element={<LendingDashboard />} />
              <Route path="BorrowerList" element={<BorrowersList />} />
              <Route path="MFBorrowers" element={<MFBorrowers />} />
              <Route path="LoanList" element={<LoanList />} />
              <Route path="LendingLoans" element={<Loans />} />
              <Route path="PurchaseOrderTransaction" element={<TransPurchaseOrder />} />
              <Route path="ReceivingTransaction" element={<TransReceivingReport />} />
              <Route path="ReceivingPOTransaction" element={<TransReceivingReportWithPO />} />
              <Route path="DeliveryTransaction" element={<TransDeliveryReceipt />} />
              <Route path="DeliveryWithSOTransaction" element={<TransDeliveryReceiptWithSO />} />
              <Route path="SalesOrderTransaction" element={<TransSalesOrder />} />



              {/* <Route path="CashReceiptTransaction" element={<CashReceiptTransaction />} />     
              <Route path="CashReceiptsTranClone" element={<CashReceiptsTranClone />} />    
              <Route path="CashReceiptsTranEdit" element={<CashReceiptsTranEdit />} />            */}
              <Route path="CashReceiptTransaction" element={<CashReceiptTransaction />} />
              <Route path="SalesOnAccountTransaction" element={<TransSalesOnAccount />} />
              <Route path="PurchaseOnAccountTransaction" element={<TransPurchaseOnAccount />} />
              <Route path="PaymentVoucherTransaction" element={<TransPaymentVoucher />} />
              <Route path="JournalVoucherTransaction" element={<TransJournalVoucher />} />
              <Route path="RecurringJVTransaction" element={<TransRecurringJV />} />
              <Route path="Report_ARAging" element={<Report_ARAging />} />
              
              <Route path="Report_LiquidationReport" element={<Report_LiquidationReport />} />

              <Route path="Report_Isaca_IS" element={<Report_ISACA_IS />} />
              <Route path="Report_Isaca_BS" element={<Report_ISACA_BS />} />
              <Route path="Report_Isaca_TB" element={<Report_ISACA_TB />} />


              <Route path="AUD_CompanyProfile" element={<AUD_CompanyProfile />} />
              <Route path="form" element={<Form />} />
              <Route path="bar" element={<Bar />} />
              <Route path="pie" element={<Pie />} />
              <Route path="line" element={<Line />} />
              <Route path="faq" element={<FAQ />} />
              <Route path="calendar" element={<Calendar />} />
              <Route path="geography" element={<Geography />} />
              <Route path="settings/change-password" element={<ChangePassword />} />

            </Routes>
        </div>
   
          </main>
        </div>
      </ThemeProvider>
    </ColorModeContext.Provider>
        </UserProvider>
    </LocalizationProvider>

  );
};


const styles = {
  topbarSticky: {
    position: "sticky",
    top: 0,
    zIndex: 1200,      // above content; MUI AppBar is 1100 by default
    background: "inherit",
  },
  pageBody: {
    paddingTop: 8,     // optional spacing below topbar
  },
};

export default AppWrapper;
